import get from "lodash/get"

const styles = theme => ({
    checkboxContainer: {
        display: "flex",
        alignItems: "center",
    },

    checkbox: {
        cursor: "pointer",
        marginRight: theme?.spacing(),
        outline: "none",
    },

    formLabel: {
        display: "inline-block",
        lineHeight: "19px",
        cursor: "pointer",
    },

    text: {
        color: get(theme, "palette.primary.contrastText"),

        "& > span": {
            color: theme?.palette?.error?.main,
        },
    },

    helperText: {
        paddingLeft: `calc((${theme?.spacing(1.5)}px) + 24px)`,
    },
})

export default styles
